import type { FinalizedPaymentStatus } from "@shyne/shared/api";
import { api } from "@/lib/api";
import { payerParties, RECIPIENT_KIND, type PaymentDateRange, type PaymentRecipientType, type PaymentScope } from "@/services/stripe-subs-payments.service";

export interface FinalizeStripePaymentDuePayload {
  kind: "due" | "extra";
  recipientType: PaymentRecipientType;
  recipientId: string;
  paymentIntentId: string;
  dateRange?: PaymentDateRange;
  paymentScope?: PaymentScope;
  amount?: number;
  description?: string;
}

export interface FinalizeStripePaymentDueResponse {
  payoutId: string | null;
  status: FinalizedPaymentStatus;
}

export async function finalizeStripePaymentDue(payload: FinalizeStripePaymentDuePayload): Promise<FinalizeStripePaymentDueResponse> {
  const { payout, status } = await api.paymentDues.finalizePayment(RECIPIENT_KIND[payload.recipientType], payload.recipientId, {
    ...payerParties(payload.dateRange, payload.paymentScope),
    kind: payload.kind,
    paymentIntent: payload.paymentIntentId,
    ...(payload.amount === undefined ? {} : { amountCents: Math.round(payload.amount * 100) }),
    ...(payload.description ? { description: payload.description } : {}),
  });
  return { payoutId: payout, status };
}
